/**
 * @param style 
 * @deprecated 废弃
 */
export const getLegendBottomNoScroll = function (style: any) {
  let legend = {
    // type: "scroll",
    show: true,
    left: "center",
    bottom: "0%",
    // icon: "circle", //采用默认symbol作为图例
    orient: "horizontal",
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 600,
      padding: [0, 0, 0, 0],
    }
  }
  return legend;
}
/**
 * 右侧带翻页图例
 * @param style 
 */
export const getLegendRightScroll = function (style: any) {
  let legend = {
    show: true,
    type: "scroll",
    right: 0,
    orient: "vertical",
    top: "14%",
    bottom: "12%",
    width: 100,
    // icon: "circle", //采用默认symbol作为图例
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    pageIconSize: style.fontSize,
    pageTextStyle: {
      fontSize: style.fontSize
    },
    pageIcons: {
      vertical: [
        "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
        "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
      ],
      pageIconColor: "#1D9FC0"
    },
    selected: {},
    // pageIcons:
    // [
    //   "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
    //   "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
    // ],
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 500,
      padding: [2, 0, 0, 0],
      // color: "#666666"
    },
  }
  return legend;
}
export const getTopLegend = function (style: any) {
  let legend = {
    show: false,
    type: "scroll",
    right: "0%",
    orient: "vertical",
    top: "14%",
    bottom: "12%",
    width: 100,
    // icon: "circle", //采用默认symbol作为图例
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    pageIconSize: style.fontSize,
    pageTextStyle: {
      fontSize: style.fontSize
    },
    pageIcons: {
      vertical: [
        "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
        "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
      ],
      pageIconColor: "#1D9FC0"
    },
    selected: {},
    // pageIcons:
    // [
    //   "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
    //   "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
    // ],
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 600,
      padding: [2, 0, 0, 0],
    },
  }
  return legend;
}
/**
 * 不显示图例
 */
export const getLegendNotShow = function (style: any) {
  let legend = {
    show: false,
    type: "scroll",
    right: "0%",
    orient: "vertical",
    top: "14%",
    bottom: "12%",
    width: "100",
    // icon: "circle", //采用默认symbol作为图例
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    pageIconSize: style.fontSize,
    pageIcons: {
      vertical: [
        "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
        "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
      ],
      pageIconColor: "#1D9FC0"
    },
    // pageIcons:
    // [
    //   "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
    //   "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
    // ],
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 600,
      padding: [2, 0, 0, 0],
    },
  }
  return legend;
}
// 获取横向图例配置 (horizontal_legend)
/**
 * 获取横向图例配置
 * @param style 
 * @deprecated 已废弃
 */
export const getHorizontalLegend = function (style: any) {
  let horizontal_legend = {
    show: true,
    top: 'bottom',
    icon: 'circle',
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 600,
      padding: 0,
    }
  }
  return horizontal_legend;
}
// 获取悬浮图例配置 (bar图)
/**
 * 获取above图例
 * @param style 
 * @deprecated 废弃
 */
export function getAboveBlock(style: any) {
  const aboveblock_legend = {
    show: true,
    top: 'center',
    orient: 'vertical',
    right: '5%',
    // icon: 'circle',
    // data: seriesName,
    borderWidth: 0.5,
    backgroundColor: '#fff',
    borderColor: '#222',
    border: 1,
    shadowBlur: 5,
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowOffsetX: 2,
    shadowOffsetY: 2,
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    textStyle: {
      fontWeight: 600,
      fontSize: style.fontSize - 1,
      padding: [0, 6, 0, 0]
    }
  }

  return aboveblock_legend;
}

//todo 声学分析lengend
export const getNoiseAnalysisLineLegend = function (style, monitorlist, rectlegend) {
  let legend = [{
    selectedMode: false,
    icon: "circle",
    type: 'scroll',
    itemWidth: 8,
    itemHeight: 8,
    itemGap: style.legend[0].itemGap,
    textStyle: {
      fontSize: 10,
    },
    left: style.legend[0].left,
    top: 70,
    data: monitorlist
  },
  {
    icon: "rect",
    left: style.legend[1].left,
    top: 10,
    itemWidth: 8,
    itemHeight: 8,
    itemGap: style.legend[1].itemGap,
    data: rectlegend
  }
  ]
  return legend;
}

// export type legendPageType = 'scroll' | 'plain';
/**
 * 底部滚动scroll
 * @param style 
 */
export const getLegendBottomScroll = (style) => {
  let legend = {
    type: 'scroll' as 'scroll' | 'plain',
    show: true,
    // left: "6%",
    // right: "6%",
    width: '80%',
    bottom: "0%",
    // icon: "circle", //采用默认symbol作为图例
    orient: "horizontal",
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    pageIconSize: style.fontSize,
    pageTextStyle: {
      fontSize: style.fontSize
    },
    pageIcons: {
      horizontal: [
        "path://M608.83203856 763.74075908a17.92707108 17.92707108 0 0 1-12.63858505-5.28848603L362.42444857 524.6832681a17.92707108 17.92707108 0 0 1 0-25.36680515L596.19345351 265.547458a17.92707108 17.92707108 0 0 1 25.36680565 25.27717011L400.42983877 511.955048 621.56025915 733.08546789a17.92707108 17.92707108 0 0 1-12.7282206 30.65529119z",
        "path://M405.23482615 763.74093902A17.84764138 17.84764138 0 0 1 392.65223874 733.22147197l221.22151621-221.31075498L392.65223874 290.68920077a17.84764138 17.84764138 0 0 1 0-25.16517434 17.84764138 17.84764138 0 0 1 25.16517435 0L651.79999324 499.41736833a17.84764138 17.84764138 0 0 1 1e-8 25.2544126L417.81741309 758.56512283a17.84764138 17.84764138 0 0 1-12.58258694 5.17581619z",
        // "path://M621.2 249.8c-6.1-0.1-10.6 3.1-14.7 7.2-41 41.1-82.1 82.1-123.2 123.2L366.5 497c-10.4 10.4-10.4 19.2 0 29.5 63 63 126 126.1 189.1 189.1l51.6 51.6c9.5 9.5 18.2 9.6 27.7 0.2 7.5-7.4 14.9-14.9 22.3-22.3 10.3-10.3 10.3-18.4 0-28.7L470.1 529.3c-4.7-4.7-9.2-9.5-14-13.9-2.6-2.4-2.9-3.9-0.1-6.6 10.7-10.4 21.2-21 31.7-31.6l168.8-168.8c2.3-2.3 4.6-4.7 6.2-7.6 3.7-6.8 2.5-13.9-3.9-20.6-8.3-8.6-16.8-16.9-25.3-25.3-3.4-3.2-7.5-5.1-12.3-5.1z",
        // "path://M732.672 541.184l-384 384c-15.872 15.872-41.984 15.872-57.856 0-15.872-15.872-15.872-41.984 0-57.85599999L646.14400001 512l-354.81600001-354.816c-15.872-15.872-15.872-41.984 0-57.856 15.872-15.872 41.984-15.872 57.856 0l384 384c7.68 7.68 11.776 17.91999999 11.776 29.184 0 10.24-4.608 20.992-12.288 28.672z"

      ],
      pageIconColor: "#1D9FC0"
    },
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 500,
      padding: 0,
    }
  }
  return legend;
}
/**
 * 顶部带翻页图例
 * @param style 
 */
export const getLegendTopScroll = (style) => {
  let legend = {
    type: "scroll",
    show: true,
    left: "center",
    top: "3%",
    icon: "circle",
    orient: "horizontal",
    itemGap: 8,
    itemWidth: style.fontSize - 2,
    itemHeight: style.fontSize - 2,
    pageIconSize: style.fontSize,
    pageTextStyle: {
      fontSize: style.fontSize
    },
    pageIcons: {
      horizontal: [
        "path://M608.83203856 763.74075908a17.92707108 17.92707108 0 0 1-12.63858505-5.28848603L362.42444857 524.6832681a17.92707108 17.92707108 0 0 1 0-25.36680515L596.19345351 265.547458a17.92707108 17.92707108 0 0 1 25.36680565 25.27717011L400.42983877 511.955048 621.56025915 733.08546789a17.92707108 17.92707108 0 0 1-12.7282206 30.65529119z",
        "path://M405.23482615 763.74093902A17.84764138 17.84764138 0 0 1 392.65223874 733.22147197l221.22151621-221.31075498L392.65223874 290.68920077a17.84764138 17.84764138 0 0 1 0-25.16517434 17.84764138 17.84764138 0 0 1 25.16517435 0L651.79999324 499.41736833a17.84764138 17.84764138 0 0 1 1e-8 25.2544126L417.81741309 758.56512283a17.84764138 17.84764138 0 0 1-12.58258694 5.17581619z",
      ],
      pageIconColor: "#1D9FC0"
    },
    textStyle: {
      fontSize: style.fontSize - 1,
      fontWeight: 500,
      padding: 0,
    }
  }
  return legend;
}


//todo 声学分析droplengend
export const getNoiseDropLineLegend = function (style,legenddata) {
  let legend = {
    // selectedMode: false,
    icon: "circle",
    type: 'scroll',
    orient: 'horizontal',
    itemWidth: style.legend.itemSize,
    itemHeight: style.legend.itemSize,
    itemGap: style.legend.itemGap,
    pageIconSize: style.legend.itemSize,
    pageTextStyle: {
      fontSize: style.legend.itemSize
    },
    pageIcons: {
      horizontal: [
        "path://M608.83203856 763.74075908a17.92707108 17.92707108 0 0 1-12.63858505-5.28848603L362.42444857 524.6832681a17.92707108 17.92707108 0 0 1 0-25.36680515L596.19345351 265.547458a17.92707108 17.92707108 0 0 1 25.36680565 25.27717011L400.42983877 511.955048 621.56025915 733.08546789a17.92707108 17.92707108 0 0 1-12.7282206 30.65529119z",
        "path://M405.23482615 763.74093902A17.84764138 17.84764138 0 0 1 392.65223874 733.22147197l221.22151621-221.31075498L392.65223874 290.68920077a17.84764138 17.84764138 0 0 1 0-25.16517434 17.84764138 17.84764138 0 0 1 25.16517435 0L651.79999324 499.41736833a17.84764138 17.84764138 0 0 1 1e-8 25.2544126L417.81741309 758.56512283a17.84764138 17.84764138 0 0 1-12.58258694 5.17581619z",
      ],
      pageIconColor: "#1D9FC0"
    },
    textStyle: {
      fontSize: style.legend.fontSize,
      fontWeight: 600,
      padding: 0,
    },
    // top: 'bottom',
    bottom: "0%",
    legenddata: legenddata
  }
  return legend;
}

export const rightLegendWidth = 95; //像素值
export const bottomLegendHeight = 30; //像素值
export const topLegendHeight = 0;

